import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between pointer-events-auto" }
const _hoisted_2 = { class: "flex items-center pointer-events-auto" }
const _hoisted_3 = { class: "relative leading-none top-px pointer-events-auto" }
const _hoisted_4 = { class: "flex items-center pointer-events-auto" }
const _hoisted_5 = { class: "relative mx-[4px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0" }
const _hoisted_6 = { class: "relative mx-[4px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0 hidden md:block" }
const _hoisted_7 = { class: "relative settings-menu mx-[4px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DarkSwtichBtn = _resolveComponent("DarkSwtichBtn")!
  const _component_LanguageMenu = _resolveComponent("LanguageMenu")!
  const _component_ToggleFullscreenBtn = _resolveComponent("ToggleFullscreenBtn")!
  const _component_NotificationsLists = _resolveComponent("NotificationsLists")!
  const _component_AdminProfile = _resolveComponent("AdminProfile")!
  const _component_SettingsBtn = _resolveComponent("SettingsBtn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'header-area bg-white dark:bg-[#0c1427] py-[13px] px-[20px] md:px-[25px] fixed top-0 z-[6] transition-all shadow-md dark:shadow-xl pointer-events-auto',
      { active: _ctx.stateStoreInstance?.open },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "hide-sidebar-toggle transition-all inline-block hover:text-primary-500 pointer-events-auto top-menu-item",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance?.onChange && _ctx.stateStoreInstance?.onChange(...args)))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " menu ", -1)
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DarkSwtichBtn)
        ]),
        _createVNode(_component_LanguageMenu),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ToggleFullscreenBtn)
        ]),
        _createVNode(_component_NotificationsLists),
        _createVNode(_component_AdminProfile),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_SettingsBtn)
        ])
      ])
    ])
  ], 2))
}